import React from 'react';
import { Modal, Button, Badge, Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface ProfileModalProps {
  show: boolean;
  onHide: () => void;
  user: any;
}

const ProfileModal: React.FC<ProfileModalProps> = ({ show, onHide, user }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = () => {
    logout();                 // ✅ clear auth/session
    onHide();                 // ✅ close modal
    navigate('/login', { replace: true }); // ✅ redirect safely
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi-person-circle me-2"></i>
          Profile
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="border-0">
          <Card.Body className="p-0">
            <div className="text-center mb-3">
              <div
                className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center"
                style={{ width: 64, height: 64, fontSize: 24 }}
              >
                {user.name?.charAt(0).toUpperCase()}
              </div>

              <h5 className="mt-2 mb-0">{user.name}</h5>
              <small className="text-muted">{user.email}</small>
            </div>

            <hr />

            <div className="mb-2">
              <strong>Role:</strong>{' '}
              <Badge bg="dark" className="text-uppercase">
                {user.role}
              </Badge>
            </div>

            <div className="mb-2">
              <strong>Permissions:</strong>{' '}
              {user.permissions?.includes('*') ? (
                <Badge bg="success">All Permissions</Badge>
              ) : (
                user.permissions?.map((p: string, i: number) => (
                  <Badge key={i} bg="secondary" className="me-1">
                    {p}
                  </Badge>
                ))
              )}
            </div>

            <div className="mb-2">
              <strong>Last Login:</strong>
              <div className="text-muted small">
                {user.lastLogin && !isNaN(new Date(user.lastLogin).getTime())
                  ? new Date(user.lastLogin).toLocaleString()
                  : "—"}
              </div>

            </div>
          </Card.Body>
        </Card>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>

        <Button variant="danger" onClick={handleLogout}>
          <i className="bi-box-arrow-right me-1"></i>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileModal;
